import React from 'react';
import {noop} from 'lodash';

import {OrderWidget} from '/component/partial/OrderWidget';

import {styles} from './FirstOrder.style';
import {generateOnIconPress} from './FirstOrder.util';
interface FirstOrderProps {
  orderId: number | null;
  onOrderPress: (orderId: number) => void;
  firstOrderPackages: any[];
  firstOrderShippingStatus: string | null;
  hasFirstOrder: boolean;
  popoverShow: () => void;
  currentScreen: string;
}

export const FirstOrder: React.FC<FirstOrderProps> = ({
  orderId = null,
  onOrderPress = noop,
  firstOrderPackages = [],
  firstOrderShippingStatus = null,
  popoverShow = noop,
  currentScreen = '',
}) => {
  return (
    <>
      {firstOrderShippingStatus ? (
        <OrderWidget
          title="First order"
          isRightArrowIcon
          onPress={generateOnIconPress({onOrderPress}, orderId)}
          orderPackages={firstOrderPackages}
          orderShippingStatus={firstOrderShippingStatus}
          popoverShow={popoverShow}
          currentScreen={currentScreen}
          orderStatus="firstOrder"
          style={{
            basePadding: styles.firstOrderPadding,
            widgetStatusContainer: styles.firstOrderStatusContainer,
          }}
        />
      ) : null}
    </>
  );
};
